import Header from "../blocks/header";
import Dashboard from "../blocks/dashboard";
import * as React from "react";
import Toolbar from "@mui/material/Toolbar";
import Box from "@mui/material/Box";
import Copyright from "../blocks/copyright";
import BusinessIcon from '@mui/icons-material/Business';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import SearchIcon from '@mui/icons-material/Search';
import {Link, useNavigate} from "react-router-dom";
import Button from "@mui/material/Button";
import {useTranslation} from "react-i18next";
import {connect} from "react-redux";
import {getBranchUsers} from "../store/logIn";
import {useEffect, useState} from "react";
import {FormControl, InputAdornment, InputLabel, OutlinedInput} from "@mui/material";

function AllBranches(props) {
    const {t} = useTranslation()
    const navigate = useNavigate()
    const [search, setSearch] = useState('')

    useEffect(() => {
        props.getBranchUsers()
    }, [])

    const branches = props.branch_users || []

    const filtered = search.trim()
        ? branches.filter(b => (b.display_name || b.user_name || '').toLowerCase().includes(search.toLowerCase()))
        : branches

    return (
        <div className="App">
            <div className={'home page'}>
                <Header/>
                <Dashboard/>
                <Box component="main" sx={{flexGrow: 1, height: '100vh', overflow: 'auto'}}>
                    <Toolbar/>
                    <div className={'main'}>
                        <Button variant="outlined" startIcon={<ChevronLeftIcon/>} onClick={() => navigate(-1)}>
                            {t('back')}
                        </Button>
                        <h2 className={'page-title'}>{t('tashkilotlar')}</h2>

                        <div style={{marginBottom: '24px'}}>
                            <FormControl variant="outlined" style={{minWidth: 320}}>
                                <InputLabel htmlFor="search-branch">{t('search')}</InputLabel>
                                <OutlinedInput
                                    id="search-branch"
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value)}
                                    endAdornment={<InputAdornment position="end"><SearchIcon/></InputAdornment>}
                                    label={t('search')}
                                />
                            </FormControl>
                        </div>

                        <div className="row">
                            {filtered.length > 0 ? filtered.map((item, index) => (
                                <div className="col-lg-2" key={index}>
                                    <Link to={`/main/${item.id}`}>
                                        <div className="card">
                                            <div className="card-header">
                                                <BusinessIcon className={'icon-card'}/>
                                            </div>
                                            <div className="card-body">
                                                <h3 className={'text-center mb-0 text-uppercase'}>
                                                    {item.display_name || item.user_name}
                                                </h3>
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                            )) : (
                                <div className={'no-infos'}>{t('no_info')}</div>
                            )}
                        </div>
                    </div>
                    <Copyright/>
                </Box>
            </div>
        </div>
    );
}

export default connect(props => props.login, {getBranchUsers})(AllBranches)
